import type { SeoResolver } from '../types';

/** SEO for a selected health facility. Moved verbatim from SEO.tsx. */
export const healthSeoResolver: SeoResolver = (ctx) => {
  const facility = ctx.selections.healthFacility;
  if (!facility) return null;

  const { siteName, layerName } = ctx;
  const p = facility.properties;

  return {
    title: `${p.facility_n || 'Health Facility'} | ${layerName} in ${p.district_n || 'Tamil Nadu'} | ${siteName}`,
    description: `Find ${p.facility_n || 'this health facility'} (${p.facility_t || 'Health Center'}) in ${p.block_name || 'Tamil Nadu'}. View location and service details on ${siteName}.`,
    breadcrumbLabel: p.facility_n || ''
  };
};
